/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Loading_MoreInputs */

const vi_customer_loading_more = /** @type {(inputs: Customer_Loading_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải thêm...`)
};

/**

* @param {Customer_Loading_MoreInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_loading_more = /** @type {((inputs?: Customer_Loading_MoreInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Loading_MoreInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_loading_more(inputs)
});